import generateAPI from "../api.generator.tanstack";

export type GeneratedAccessCard = {
  guestId: string;
  guestName: string;
  publicUrl: string;
  qrPayload: string;
};

export type AccessCardGeneration = {
  _id: string;
  weddingId: string;
  eventId: string;
  status: "completed";
  requested: number;
  generated: number;
  accessCards: GeneratedAccessCard[];
  createdAt: string;
  updatedAt: string;
};

export type GenerateAccessCardsParams = {
  eventId: string;
  guestIds: string[];
};

export const useGenerateAccessCards = generateAPI<
  { body: GenerateAccessCardsParams },
  AccessCardGeneration
>("post", "wedding/access-cards/generate", { skipAutoInvalidation: true });
